import React from "react";

function GercelSayiAraliklariKumeIslemleri() {
  return <div>GercelSayiAraliklariKumeIslemleri</div>;
}

export default GercelSayiAraliklariKumeIslemleri;
